import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/helpers/shadcn';

const METHODS = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'];

// Clients that name themselves with the x-zebel-source header (request_logs.source).
const SOURCES = [{ value: 'rabbit', label: 'Zebel Rabbit' }];

const FilterBar = ({
  startDate,
  endDate,
  methods,
  routeGroup,
  statusFilter,
  source,
  onStartDateChange,
  onEndDateChange,
  onMethodToggle,
  onRouteGroupChange,
  onStatusFilterChange,
  onSourceChange,
  onReset
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className="h-8 w-36 text-xs" />
      <span className="text-xs text-muted-foreground">to</span>
      <Input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className="h-8 w-36 text-xs" />

      <div className="h-6 w-px bg-border" />

      <div className="flex gap-1">
        {METHODS.map((method) => (
          <Button
            key={method}
            variant={methods.includes(method) ? 'default' : 'outline'}
            size="sm"
            className={cn('h-8 px-3 text-xs font-medium')}
            onClick={() => onMethodToggle(method)}
          >
            {method}
          </Button>
        ))}
      </div>

      <div className="h-6 w-px bg-border" />

      <Select value={routeGroup} onValueChange={onRouteGroupChange}>
        <SelectTrigger className="h-8 w-32 text-xs">
          <SelectValue placeholder="Route Group" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Groups</SelectItem>
          <SelectItem value="private">Private</SelectItem>
          <SelectItem value="public">Public</SelectItem>
          <SelectItem value="admin">Admin</SelectItem>
        </SelectContent>
      </Select>

      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="h-8 w-28 text-xs">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Status</SelectItem>
          <SelectItem value="2xx">2xx</SelectItem>
          <SelectItem value="3xx">3xx</SelectItem>
          <SelectItem value="4xx">4xx</SelectItem>
          <SelectItem value="5xx">5xx</SelectItem>
        </SelectContent>
      </Select>

      <Select value={source} onValueChange={onSourceChange}>
        <SelectTrigger className="h-8 w-36 text-xs">
          <SelectValue placeholder="Source" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Sources</SelectItem>
          {SOURCES.map(({ value, label }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button variant="ghost" size="sm" onClick={onReset} className="h-8 gap-1.5 text-xs text-muted-foreground">
        <RotateCcw className="h-3.5 w-3.5" />
        Reset
      </Button>
    </div>
  );
};

export default FilterBar;
